import React from 'react';
import { Typography } from 'components/atoms';
import './index.scss';

interface QuickActionsProps {
  onMyGoalsClick: () => void;
  onScheduleReviewClick: () => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({
  onMyGoalsClick,
  onScheduleReviewClick
}) => {
  return (
    <div className="quick-actions-card">
      <div className="card-header">
        <Typography type="heading5" text="Quick Actions" weight="bold" />
      </div>

      <div className="actions-grid">
        <div className="action-item" onClick={onMyGoalsClick}>
          <div className="action-left-arrow"></div>
          <div className="action-icon">
            <i className="ri-focus-2-line"></i>
          </div>
          <div className="action-content">
            <Typography type="base_medium" text="Employee Goals" weight="bold" />
            <Typography
              type="small_regular"
              text="View & Update"
              color="gray"
            />
          </div>
          <div className="action-arrow">
            <i className="ri-arrow-right-s-line"></i>
          </div>
        </div>

        <div className="action-item" onClick={onScheduleReviewClick}>
          <div className="action-left-arrow"></div>
          <div className="action-icon">
            <i className="ri-calendar-event-line"></i>
          </div>
          <div className="action-content">
            <Typography
              type="base_medium"
              text="Schedule Review"
              weight="bold"
            />
            <Typography type="small_regular" text="Book Meeting" color="gray" />
          </div>
          <div className="action-arrow">
            <i className="ri-arrow-right-s-line"></i>
          </div>
        </div>

        {/* <div className="action-item" onClick={handleAnalytics}>
          <div className="action-icon">
            <i className="ri-bar-chart-line"></i>
          </div>
          <div className="action-content">
            <Typography type="base_medium" text="Analytics" weight="bold" />
            <Typography type="small_regular" text="View Reports" color="gray" />
          </div>
          <div className="action-arrow">
            <i className="ri-arrow-right-s-line"></i>
          </div>
        </div> */}
      </div>
    </div>
  );
};
